import { Component, OnInit } from '@angular/core';
import { ConfirmationService } from 'primeng/api';
import { MaintenanceService } from '../services/maintenance.service';
import { UserService} from '../services/user.service';
import { Router } from '@angular/router';
import { Message, SelectItem} from 'primeng/primeng';
import { DeviceService} from '../services/device.service';
import { MaintenanceTypeService} from '../services/maintenance-type.service';

@Component({
  selector: 'app-maintenance',
  templateUrl: './maintenance.component.html',
  styleUrls: ['./maintenance.component.css']
})
export class MaintenanceComponent implements OnInit {
  msgs: Message[] = [];
  maintenances:any[];
  maintenance:any;
  dialog: boolean;
  blocked:boolean=false;
  stateOptions: any[];
  action:String;
  devices:SelectItem[];
  maintenanceTypes:SelectItem[];
  emails: string[];
  emailRegex = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;

  constructor(private router:Router,private userService:UserService,private maintenanceService:MaintenanceService,private confirmationService: ConfirmationService,
    private deviceService:DeviceService, private maintenanceTypeService:MaintenanceTypeService
  ) { }

  ngOnInit(): void {
    this.stateOptions = [{label: 'Inhabilitado', value: 'I'}, {label: 'Habilitado', value: 'H'}];
    this.devices = [];
    this.deviceService.findByUserBranch(this.userService.userLoged.idUser).then(data => {
      let response: any = data;
      response.devices.forEach(item => {
        this.devices.push({label: item.name, value: item.idDevice});
      });
    }).catch(err =>{
      console.log(err);
      this.msgs = [{severity:'error', summary:'ERROR', detail:"Existe algun problema con la conexión al servidor"}];
    });
    this.maintenanceTypes=[];
    this.maintenanceTypeService.findAll().subscribe(response => {
      if(response.status == 'OK'){
        response.maintenanceTypes.forEach(item => {
          this.maintenanceTypes.push({label: item.name, value: item});
        });
      }else{
        this.msgs = [{severity:'error', summary:'ERROR', detail:response.message}];
      }
    }, error =>{
      console.error(error);
      this.msgs = [{severity:'error', summary:'ERROR', detail:"Existe algun problema con la conexión al servidor"}];
    });
    this.init();
  }

  init(){
    if(this.userService.userLoged.idProfile == 1){
      this.maintenanceService.findAll().subscribe(response => {
        if(response.status == 'OK'){
          this.maintenances = [...response.maintenances];
        }else{
          this.msgs = [{severity:'error', summary:'ERROR', detail:response.message}];
        }
      }, error =>{
        console.error(error);
        this.msgs = [{severity:'error', summary:'ERROR', detail:"Existe algun problema con la conexión al servidor"}];
      });
    }else{
      this.maintenanceService.findByUser(this.userService.userLoged.idUser).subscribe(response => {
        if(response.status == 'OK'){
          this.maintenances = [...response.maintenances];
        }else{
          this.msgs = [{severity:'error', summary:'ERROR', detail:response.message}];
        }
      }, error =>{
        console.error(error);
        this.msgs = [{severity:'error', summary:'ERROR', detail:"Existe algun problema con la conexión al servidor"}];
      });
    }


    this.hideDialog();
  }

  openNew() {
    this.action="CREATE";
    this.dialog = true;
  }

  hideDialog() {
    this.dialog = false;
    this.maintenance = {status:"H",email:"",user:{idUser:this.userService.userLoged.idUser}};
    this.emails=[];
  }

  edit(maintenance: any) {
    this.action="UPDATE";
    this.maintenance = {...maintenance};
    this.emails = this.maintenance.email.split(";");
    this.dialog = true;
  }

  validateEmails():boolean{
    if(!this.emails || this.emails.length == 0){
      this.msgs = [{severity:'error', summary:'ERROR', detail:"Debe introducir por lo menos un correo electrónico"}];
      return false;
    }
    if(this.emails.length > 2){
      this.msgs = [{severity:'error', summary:'ERROR', detail:"Solo puede introducir dos correos electrónicos para la notificación"}];
      return false;
    }
    let emailsValidos = true;
    this.emails.forEach(item => {
      if(item != null && item != "" && !this.emailRegex.test(item)){
        emailsValidos = false;
      }
    });
    if(!emailsValidos){
      this.msgs = [{severity:'error', summary:'ERROR', detail:"Formato de email no válido"}];
      return false;
    }
    return true;
  }

  save() {
    if(!this.validateEmails()){
      return;
    }
    this.maintenance.email = "";
    this.emails.forEach(item => {
      this.maintenance.email += item + ";"
    });
    this.maintenance.email =  this.maintenance.email.substring(0,this.maintenance.email.length-1)
    this.blocked = true;
    if (this.action == "UPDATE") {
      this.maintenanceService.edit(this.maintenance).subscribe(response => {
        if(response.status == 'OK'){
          this.init();
          this.msgs = [{severity:'success', summary:'EXITO', detail:"Registro modificado exitosamente"}];
        }else{
          this.msgs = [{severity:'error', summary:'ERROR', detail:response.message}];
        }
        this.blocked = false;
      }, error =>{
        console.error(error);
        this.msgs = [{severity:'error', summary:'ERROR', detail:"Existe algun problema con la conexión al servidor"}];
        this.blocked = false;
      });
    }else {
      this.maintenanceService.create(this.maintenance).subscribe(response => {
        if(response.status == 'OK'){
          this.init();
          this.msgs = [{severity:'success', summary:'EXITO', detail:"Registro insertado exitosamente"}];
        }else{
          this.msgs = [{severity:'error', summary:'ERROR', detail:response.message}];
        }
        this.blocked = false;
      }, error =>{
        console.error(error);
        this.msgs = [{severity:'error', summary:'ERROR', detail:"Existe algun problema con la conexión al servidor"}];
        this.blocked = false;
      });
    }

  }

  delete(maintenance:any) {
    this.confirmationService.confirm({
      message: 'Esta seguro que desea eliminar el registro de manteimiento del vehiculo ' + maintenance.device.name + '?',
      header: 'Eliminar Mantenimiento',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.blocked = true;
        this.maintenanceService.remove(maintenance).subscribe(response => {
          if(response.status == 'OK'){
            this.init();
            this.msgs = [{severity:'success', summary:'EXITO', detail:"Registro eliminado exitosamente"}];
          }else{
            this.msgs = [{severity:'error', summary:'ERROR', detail:response.message}];
          }
          this.blocked = false;
        }, error =>{
          console.error(error);
          this.msgs = [{severity:'error', summary:'ERROR', detail:"Existe algun problema con la conexión al servidor"}];
          this.blocked = false;
        });
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/maintenance/maintenance.component.ts